import { Injectable } from '@angular/core';

@Injectable()
export class CustomHorizontalScrollService {
    constructor() { }

    public toggleHorizontalScroll(toggleOn: boolean = true) {
        //get all the tables in the page that might require top scroll
        var tables = $('table.table_list_2');
        $(tables).each(function (i) {
            //table that needs top scroll
            var currentTable = this;
            //parent div of the table with the class table-scroll
            var parentDiv = $(this).parent();
            //closest div containing top scroll
            var scrollHint = $(parentDiv).parent().find('.scroll-hint');
            //parent div of closest scroll
            var scrollHintParent = $(parentDiv).parent().find('.scroll-hint-parent');
            //if scroll was toggled on
            if (toggleOn) {
                //add scroll if content width exceeds parent width
                if ($(parentDiv).width() - $(this).width() < 0) {
                    //show scroll
                    $(scrollHintParent).removeClass('hidden-scroll');                
                } else {
                    //if scroll was toggled on but is not needed, do not show
                    $(scrollHintParent).addClass('hidden-scroll');
                    $(scrollHint).width(0);
                }
            } else {
                //if scroll was toggled off, hide scroll
                $(scrollHintParent).addClass('hidden-scroll');
                $(scrollHint).width(0);
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/custom-horizontal-scroll.service.ts